module.exports = __webpack_public_path__ + "img/phone1.4f6d034d.png";